import { requestUtils } from 'helpers/saga-helpers';

export const getApiBasePath = (): string => {
  return process.env.NODE_ENV === 'development'
    ? 'https://recette-gateway.sanlam.ma'
    : process.env.GATEWAY_REST_API_URL
    ? process.env.GATEWAY_REST_API_URL
    : '';
};
export const getLiveDocumentViewUrlIntervenant = (documentId: string) => {
  const baseApiPath = requestUtils.getApiBasePath();
  return `${baseApiPath}/corporeal/view-document/intervenant?documentId=${documentId}`;
};
